import styled from 'styled-components';
// @ts-ignore
import rtl from 'styled-components-rtl';
import { theme, toRem } from '@marriott/mi-ui-library-shop';

export const StyledEventDatesDiv = styled.div`
  ${rtl`
  .eventDates{
    @media ${theme.mediaQuery.tabletMax} {
      justify-content: center;
      .flexibleDates{
        margin-top: ${toRem(-16)};
      }
    }
  }
`}
`;
